import React, { useState, useEffect } from "react";
import { useAuth } from "../AuthContext";
import axios from "axios";
import AddLog from "./AddLog"; // ✅ 로그 저장 함수 가져오기
import "../styles/UserEditModal.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; 

const PartnerEditModal = ({ glist, selectedPartner, onClose, onSave, onPartnerAdded, }) => {    
    const { user } = useAuth();
    const [editedPartner, setEditedPartner] = useState(selectedPartner);
    
    // 카카오 주소 검색
    const handleSearchAddress = () => {
        new window.daum.Postcode({
            oncomplete: (data) => {
                // 주소 값을 상태에 저장
                setEditedPartner((prev) => ({ ...prev, location1: data.address }));
            },
            width: 500, // 창 너비
            height: 600, // 창 높이
        }).open({
            left: (window.screen.width / 2) - 250,  // 중앙 정렬 (화면 너비 기준)
            top: (window.screen.height / 2) - 300   // 중앙 정렬 (화면 높이 기준)
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedPartner((prev) => ({ ...prev, [name]: value }));
    };

    const handleDelete = async () => {
        const DeletePartner = editedPartner.partnerCode;

        if (!DeletePartner) {
            alert("파트너 ID가 없습니다.");
            return;
        }

        if (window.confirm(`${DeletePartner} 파트너를 정말 삭제하시겠습니까?`)) {
            // 삭제 로직 추가
            try {

                const response = await axios.delete(`${API_BASE_URL}/api/Partner/delete-partner?partnerCode=${DeletePartner}`);

                if (response.status === 204) {

                    await AddLog(user.userId, "", DeletePartner, "6-4");

                    alert("사용자가 삭제되었습니다.");
                    //onSave();  // 리스트 갱신을 요청하는 콜백 호출
                    onPartnerAdded();
                    onClose();
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    alert("삭제 할 사용자를 찾을 수 없습니다.");
                } else {
                    alert("삭제 중 오류발생.");
                }
            }
        }
    };

    const handleSave = async () => { // 'async' 추가

        if (!editedPartner.partnerName.trim()) {
            alert("파트너명을 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("partnerName")[0].focus();
            }, 0);
            return;
        }
        else if (!editedPartner.partnerBusinessNum.trim()) {
            alert("사업자번호를 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("partnerBusinessNum")[0].focus();
            }, 0);
            return;
        }
        else if (!editedPartner.representativeName.trim()) {
            alert("대표자명을 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("representativeName")[0].focus();
            }, 0);
            return;
        }
        else if (!editedPartner.location1.trim()) {
            alert("주소검색으로 기본 소재지를 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("location1bt")[0].focus();
            }, 0);
            return;
        }
        else if (!editedPartner.location2.trim()) {
            alert("나머지 소재지를 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("location2")[0].focus();
            }, 0);
            return;
        }

        editedPartner.partnerName = editedPartner.partnerName.trim();
        editedPartner.partnerBusinessNum = editedPartner.partnerBusinessNum.trim();
        editedPartner.representativeName = editedPartner.representativeName.trim();
        editedPartner.location2 = editedPartner.location2.trim();

        const updatePartner = {
            PartnerCode: editedPartner.partnerCode,
            PartnerName: editedPartner.partnerName,
            OfficeNumber: editedPartner.partnerBusinessNum,
            OwnerName: editedPartner.representativeName,
            Address1: editedPartner.location1,
            Address2: editedPartner.location2,
            GovernmentCode: editedPartner.governmentCode,
        };
        //console.log("사용자 수정 정보:", JSON.stringify(updateUser, null, 2));
        //alert(updateUser.UserId);

        try {

            const response = await fetch(`${API_BASE_URL}/api/Partner/update-partner`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updatePartner),
            });

            const data = await response.json();
            if (response.ok) {

                await AddLog(user.userId, "", editedPartner.partnerCode, "6-2");

                alert("파트너 정보 변경이 완료되었습니다.");
                Account_Update();

                                
                onSave(editedPartner);
                onClose();
            } else {
                alert("파트너 정보 변경이 실패했습니다: " + data.message);
                //console.log("응답 상태 코드:", response.status);
                //console.log("서버 응답 데이터:", data);
            }

        } catch (error) {
            //console.error("오류:", error);
            alert("파트너 정보 변경 중 오류가 발생했습니다.");
        }

        onClose(); // 팝업 닫기
    };

    const Account_Update = async () => {
        const updateGovernment = {
            PartnerCode: editedPartner.partnerCode,
            GovernmentCode: editedPartner.governmentCode,
        };
        //console.log("보내는 데이터:", JSON.stringify(updateGovernment, null, 2));
        try {
            const response = await fetch(`${API_BASE_URL}/api/Account/update-auto-governmentCode`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updateGovernment),
            });

            const data = await response.json();
            //console.log("서버 응답:", data); // 서버 응답 확인

            if (response.ok) {   
                if (data.message > 0) {

                    await AddLog(user.userId, "", `${data.message}`, "6-5");
                    alert(data.message + " 건의 사용자 정보 변경이 완료되었습니다.");
                }

                Enshrine_Update();
                //console.log("사용자 정보 변경 성공:", data.message);
            } else {
                //console.error("사용자 정보 변경 실패:", data.message);
                alert("사용자 정보 변경이 실패했습니다: " + data.message);
            }
        } catch (error) {
            //console.error("오류 발생:", error);
            alert("사용자 정보 변경 중 오류가 발생했습니다.");
        }
    };


    const Enshrine_Update = async () => { // 'async' 추가
        const updateGovernment = {
            PartnerCode: editedPartner.partnerCode,
            GovernmentCode: editedPartner.governmentCode,
        };
        //console.log("보내는 데이터:", JSON.stringify(updateGovernment, null, 2));
        try {
            const response = await fetch(`${API_BASE_URL}/api/Enshrine/update-auto-governmentCode`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updateGovernment),
            });

            const data = await response.json();
            //console.log("서버 응답:", data); // 서버 응답 확인

            if (response.ok) {
                if (data.message > 0) {

                    await AddLog(user.userId, "", `${data.message}`, "6-6");
                    alert(data.message + " 건의 봉안 정보 변경이 완료되었습니다.");
                }
                //console.log("봉안 정보 변경 성공:", data.message);
            } else {
                //console.error("봉안 정보 변경 실패:", data.message);
                alert("봉안 정보 변경이 실패했습니다: " + data.message);
            }
        } catch (error) {
            //console.error("오류 발생:", error);
            alert("봉안 정보 변경 중 오류가 발생했습니다.");
        }
    };

    

    return (
        <div className="addmodal-overlay">
            <div className="addmodal-content">

                {/* 모달 헤더 */}
                <div className="addmodal-header">
                    <h2>{editedPartner.snum}.{editedPartner.partnerCode} Update</h2>
                    <button className="addmodal-close-btn" onClick={onClose}><i className="fa fa-times-circle"></i></button>
                </div>                

                <div className="addform-group">
                    <label>파트너명</label>
                    <div className="addinput-group">
                        <input type="text" maxLength="18" name="partnerName" value={editedPartner.partnerName} onChange={handleChange} />
                    </div>
                </div>

                <div className="addform-group">
                    <label>사업자번호</label>
                    <div className="addinput-group">
                        <input type="text" maxLength="18" name="partnerBusinessNum" value={editedPartner.partnerBusinessNum} onChange={handleChange} />
                    </div>
                </div>

                <div className="addform-group">
                    <label>대표자명</label>
                    <div className="addinput-group">
                        <input type="text" maxLength="18" name="representativeName" value={editedPartner.representativeName} onChange={handleChange} />
                    </div>
                </div>                

                <div className="addform-group">
                    <label>소재지1</label>
                    <div className="addinput-group">
                        <input type="text" name="location1" readOnly value={editedPartner.location1 || ""} onChange={handleChange} />
                        <button name="location1bt" className="addsearch-btn" onClick={handleSearchAddress}><i className="fa fa-search"></i></button>
                    </div>
                </div>

                <div className="addform-group">
                    <label>소재지2</label>
                    <div className="addinput-group">
                        <input type="text" maxLength="40" name="location2" value={editedPartner.location2} onChange={handleChange} />
                    </div>
                </div>  

                <div className="form-group2">
                    <label>관할광공서</label>
                    <div className="input-group2">
                        <select name="governmentCode" value={editedPartner.governmentCode} onChange={handleChange }    >
                            <option value="">관할 관공서를 선택하세요</option> {/* 기본값 */}
                            {glist.map((government) => (
                                <option key={government.snum} value={government.governmentCode}>
                                    {government.snum}, {government.governmentCode} : {government.governmentName}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>


                   
                {/* 업데이트 버튼 */}
                <div className="button-group">                    
                    <button className="delete-btn" onClick={handleDelete} style={{ backgroundColor: "red", color: "white" }}><i className="fa fa-trash"></i></button>                
                    <button className="addsave-btn" onClick={handleSave}>업데이트</button>
                </div>
              
                

            </div>
        </div>
    );
};

export default PartnerEditModal;
